import sessionStorageUtils from "@/utils/session-storage";
import forge from 'node-forge';
import { COUNTRY_CODES } from "@/utils/constants";
import { isDesktopChannel } from '@/utils/app-entities';

export default {
  methods: {
    $__handleIsamResponse(redirectUrl) {
      console.log("redirectUrl", redirectUrl);
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      let finalRedirectURL = "";
      if (redirectUrl.includes("https")) {
        finalRedirectURL = redirectUrl;
      } else {
        finalRedirectURL = protocol + "//" + hostname + redirectUrl;
      }
      if (finalRedirectURL) {
        window.location.href = finalRedirectURL;
      } else {
        this.$router.replace({
          path: "/error",
          query: { errCode: "MIDERR_005" },
        });
      }
    },

    $__maskedEmailAddress(email) {
      return email.replace(/(.{4})(.*)(?=@)/, function (gp1, gp2, gp3) {
        for (let i = 0; i < gp3.length; i++) {
          gp2 += "*";
        }
        return gp2;
      });
    },

    $__checkRequestIdISAM() {
      /* eslint-disable */
      // TODO: Remove later - start // remove the static requestId 3Y7tpzz055rBBDPF6EkJ
      // const memberIdRequestID = process.env.VUE_APP_ENV != "sit" ? document.cookie.replace(
      //   /(?:(?:^|.*;\s*)MEMBERID-REQUEST-ID\s*\=\s*([^;]*).*$)|^.*$/,
      //   "$1"
      // ) : '3Y7tpzz055rBBDPF6EkJ';
      // TODO: Remove later - end
      const memberIdRequestID = document.cookie.replace(
        /(?:(?:^|.*;\s*)MEMBERID-REQUEST-ID\s*\=\s*([^;]*).*$)|^.*$/,
        "$1"
      );
      if (
        process.env.VUE_APP_ENV != "prod" &&
        sessionStorageUtils.getItem("overrideRequestID")
      ) {
        const overrideRequestID =
          sessionStorageUtils.getItem("overrideRequestID");
        sessionStorageUtils.setItem("requestID", overrideRequestID);
        return overrideRequestID;
      }
      if (memberIdRequestID) {
        document.cookie = "MEMBERID-REQUEST-ID=;path=/";
        return memberIdRequestID;
      }
      return this.$route?.query?.requestId ?? "";
    },

    $__checkChannelId() {
      let channelId = sessionStorageUtils.getItem("ChannelId");

      if (channelId) {
        return channelId ?? "EB-APP";
      }
      /* eslint-disable */
      channelId = document.cookie.replace(
        /(?:(?:^|.*;\s*)CHANNEL-ID\s*\=\s*([^;]*).*$)|^.*$/,
        "$1"
      );
      if (channelId) {
        document.cookie = "CHANNEL-ID=;path=/";
        return channelId;
      }
      return this.$route?.query?.channelId ?? "EB-APP";
    },

    $__checkIsDesktopChannel() {
      const id = sessionStorageUtils.getItem("ChannelId") || '';
      return isDesktopChannel(id);
    },

    $__checkAppCountry() {
      const hostname = window.location.hostname;
      const countryList = {
        my: "my",
        sg: "sg",
      };

      const matchedCountry = Object.entries(countryList).find(
        ([key, value]) =>
          hostname.toLowerCase().includes(key) ||
          hostname.toLowerCase().includes(value)
      );

      return matchedCountry ? matchedCountry[1] : "sg";
    },

    $_getTncPortalUrlByCountryCode() {
      const country = this.$__checkAppCountry()

      const urlList = {
        sg: process.env.VUE_APP_MO_TERMS_AND_CONDITIONS_URL_SG,
        my: process.env.VUE_APP_MO_TERMS_AND_CONDITIONS_URL_MY
      }

      return urlList?.[country] ?? urlList[COUNTRY_CODES.SG];
    },

    $_getTncAppUrlByCountryCode() {
      const country = this.$__checkAppCountry()

      const urlList = {
        sg: process.env.VUE_APP_FO_TERMS_AND_CONDITIONS_URL_SG,
        my: process.env.VUE_APP_FO_TERMS_AND_CONDITIONS_URL_MY
      }

      return urlList?.[country] ?? urlList[COUNTRY_CODES.SG];
    },

    $__aesUtilsDecrypt(encryptedBase64, secret) {
      const KEY_SIZE = 32; // 256 bits
      const SALT_SIZE = 16;
      const IV_SIZE = 12;
      const GCM_TAG_LENGTH = 128;
      const ITERATION_COUNT = 65536;
      
      const input = forge.util.decode64(encryptedBase64);
      const salt = input.substring(0, SALT_SIZE);
      const iv = input.substring(SALT_SIZE, SALT_SIZE + IV_SIZE);
      const tag = input.substring(input.length - 16);
      const encrypted = input.substring(SALT_SIZE + IV_SIZE, input.length - 16);
      const encodedSecretKey = forge.util.encode64(forge.util.encodeUtf8(secret));

      const key = forge.pkcs5.pbkdf2(encodedSecretKey, salt, ITERATION_COUNT, KEY_SIZE, forge.md.sha256.create());

      const decipher = forge.cipher.createDecipher('AES-GCM', key);
      decipher.start({
        iv: iv,
        tagLength: GCM_TAG_LENGTH,
        tag: tag
      });
      decipher.update(forge.util.createBuffer(encrypted, 'raw'));
      decipher.finish();

      return decipher.output.toString('utf8');
    },

    $__processDecryptResponse(data, secretKey) {
      try {
        const decryptedData = this.$__aesUtilsDecrypt(data, secretKey);
        try {
          if (!decryptedData || decryptedData === "null") {
            return null;
          }
          return JSON.parse(decryptedData);
        } catch (parseError) {
          console.error('Failed to parse decrypted data as JSON:', parseError);
          return null;
        }
      } catch (error) {
        console.error('Error in decryption process:', error);
        return null; 
      }
    },
  },
};
